<template>
  <div class="overview-info" v-if="overviewFields.length != 0 || editing">
    <div
      :class="['overview', { editing, pointer: editing }]"
      :style="from === 'sheetFront' ? 'background: #f5f7fa;' : 'background: #fffbf5;'"
    >
      <div v-if="_.isEmpty(overviewFields)" class="empty">
        {{ emptyText }}
      </div>
      <div v-else class="field-list">
        <field-item
          v-for="field in overviewFields"
          :key="field._cid"
          :control="editing ? Object.assign({}, field, { _type: 'text' }) : field"
          :value="getValue(field._cid)"
          :string-value="editing ? '-' : getValue(field._cid, 'string')"
          simple-mode
        ></field-item>
      </div>
    </div>
  </div>
</template>

<script>
import FieldItem from "@/components/Sheet/DetailDialog/DataDetail/FieldItem"

export default {
  name: "overview-info",
  components: { FieldItem },
  props: {
    overviewFields: Array,
    editing: Boolean,
    // 详情展示中需要使用
    sheetData: {
      type: Object,
      default: () => ({ data: {} })
    },
    from: String
  },
  data() {
    return {}
  },
  computed: {
    emptyText() {
      if (this.editing) return "摘要为空，添加字段后才能显示"
      else return "摘要为空"
    }
  },
  methods: {
    getValue(cid, type) {
      let commonMap = {
        createAt: this.sheetData.createAt,
        creator: this.sheetData.creator?.name,
        updateUser: this.sheetData.updateUser?.name,
        updateAt: this.sheetData.updateAt,
        owner: this.sheetData.owner?.name,
        project: this.sheetData.projectName
      }
      if (commonMap[cid] !== undefined) return commonMap[cid]
      return type === "string" ? this.sheetData.dataForShow[cid] : this.sheetData.data[cid]
    }
  }
}
</script>

<style lang="scss" scoped>
.overview-info {
  display: flex;
  flex-direction: column;
  .overview {
    height: 72px;
    box-sizing: border-box;
    font-size: $font-size-main;
    &.editing:hover {
      border-style: dashed;
      border-color: #ff8000;
    }
    .empty {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      border-radius: 4px;
      color: #777;
    }
    .field-list {
      padding: 0 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 100%;
      overflow: hidden;
      .field-item {
        &:not(:last-child) {
          margin-right: 10px;
        }
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-flow: column;
        ::v-deep {
          .label {
            justify-content: center;
            margin: 0;
          }
          .value {
            color: #333333;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
